import { takeLatest, spawn, put, select } from 'redux-saga/effects';
import { appActions } from '../../commons/reducer';

import { get } from '../../utils/api';
import { transactionListActions, TRANSACTION_LIST } from './reducer';

// Selector to get pagination params from state
const getPaginationParams = (state: any) => ({
  page: state.transactionList.params.page,
  limit: state.transactionList.params.limit,
});

function* shipmentList() {
  yield takeLatest(TRANSACTION_LIST.GET_TRANSACTION_LIST, function* fn(action: any): any {
    try {
      const { page, limit } = yield select(getPaginationParams);
      const response = yield get(`/transaction/history?page=${page}&limit=${limit}`);
      if (response.error) {
        yield put(transactionListActions.getTransactionListFailed(response.errorMsg));
      } else {
        yield put(transactionListActions.getTransactionListSuccess(response));
      }
    } catch {
      yield put(appActions.serverFailed('Oops, server failed'));
    }
  });
}
export default function* saga(): any {
  yield spawn(shipmentList);
}
